import { mapState, mapActions, mapGetters } from 'vuex'
import * as Sentry from '@sentry/vue'
import Socket from '@/socket'
import SlideOptionApi from '@/api/slideOption'
import EventBus from '@/eventBus'

export default {
  data() {
    return {
      newEntry: '',
      submitting: false,
    }
  },
  computed: {
    ...mapGetters(['isBackstage', 'isPresenting']),
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
      sharePresentation: (state) => state.sharePresentation,
    }),
    entriesPlaceholder() {
      return this.isInputExpanded
        ? this.$t('multipleEntriesPlaceholder')
        : this.$t('entriesPlaceholder')
    },
    isInputExpanded() {
      return this.newEntry
        || (this.slideActive && this.slideActive.isFocusingInput)
    },
    isAddButtonDisabled() {
      return !this.newEntry
        || this.submitting
        || this.isBackstage
        || this.sharePresentation
    },
  },
  methods: {
    ...mapActions(['updateSlideActiveAction']),
    onFocusEntryInput() {
      if (this.isShowInputEditor) {
        this._updateSlideActiveFocusingInput(true)
      }
    },
    onBlurEntryInput() {
      this._updateSlideActiveFocusingInput(false)
    },
    _updateSlideActiveFocusingInput(boolean) {
      this.updateSlideActiveAction({
        isFocusingInput: boolean,
      })
    },
    _preparePayload() {
      let rawEntries = this.newEntry
        .split(/\r?\n/)
        .filter((item) => item.trim())
      let order = 0

      if (this.slideActive.SlideOptions && this.slideActive.SlideOptions.length) {
        order = this.slideActive.SlideOptions.slice(-1)[0].order
      }

      rawEntries = rawEntries
        .map((entry) => ({
          accessCode: this.presentation.uniqueAccessCode,
          presentationId: this.presentation.id,
          order: ++order,
          slideId: this.slideActive.id,
          socketId: Socket.getSocketId(),
          title: entry.trim(),
        }))

      return {
        accessCode: this.presentation.uniqueAccessCode,
        presentationId: this.presentation.id,
        slideId: this.slideActive.id,
        socketId: Socket.getSocketId(),
        options: rawEntries,
      }
    },
    async _requestCreateEntries(payload) {
      this.submitting = true

      try {
        const {
          SlideOptions: slideOptions,
        } = await SlideOptionApi.createSpinnerWheelOptions(payload)
        this.newEntry = ''

        this.$store.state.slideActive.SlideOptions.push(...slideOptions)
        this.updateSlideActiveAction({
          SlideOptions: this.slideActive.SlideOptions,
        })
        EventBus.$emit('createEntries', slideOptions)
      } catch (e) {
        Sentry.captureException(e)
        this.$store.dispatch('setSyncPresentation', 3)
      } finally {
        this.submitting = false
      }
    },
    async submitNewEntries() {
      if (this.slideActive.wheelStatus === 'spinning') return
      if (!this.newEntry || this.submitting) return

      const payload = this._preparePayload()

      await this._requestCreateEntries(payload)
    },
  },
}
